// Procedural textures generated at runtime with Phaser Graphics.
// Keeps the game asset-free while providing a distinctive liquid look.

export function buildTextures(scene) {
  const g = scene.add.graphics({ x: 0, y: 0 });

  /*
   * NÉON — CUERPO LÍQUIDO
   *
   * Se utilizan varias elipses superpuestas en lugar de un círculo perfecto.
   * La deformación dinámica sigue realizándose desde LevelOneScene.js.
   */

  g.clear();

  // Contorno exterior semitransparente.
  g.fillStyle(0x0891b2, 0.5);
  g.fillEllipse(48, 51, 84, 76);

  // Masa principal irregular.
  g.fillStyle(0x06b6d4, 1);
  g.fillEllipse(48, 49, 76, 70);
  g.fillCircle(31, 53, 25);
  g.fillCircle(64, 52, 27);
  g.fillCircle(48, 33, 25);

  // Zona interior más clara.
  g.fillStyle(0x22d3ee, 0.9);
  g.fillEllipse(46, 45, 58, 52);

  // Reflejo líquido principal.
  g.fillStyle(0xa5f3fc, 0.65);
  g.fillEllipse(35, 34, 27, 20);

  // Reflejo secundario.
  g.fillStyle(0xe0f7ff, 0.9);
  g.fillEllipse(29, 29, 12, 9);

  // Pequeña luz interna.
  g.fillStyle(0xffffff, 0.75);
  g.fillCircle(25, 25, 4);

  // Sombra interior inferior para dar profundidad.
  g.fillStyle(0x0369a1, 0.22);
  g.fillEllipse(50, 66, 48, 16);

  g.generateTexture('blob', 96, 96);

  /*
   * HALO
   */

  g.clear();

  g.fillStyle(0x22d3ee, 0.06);
  g.fillCircle(64, 64, 62);

  g.fillStyle(0x22d3ee, 0.1);
  g.fillCircle(64, 64, 52);

  g.fillStyle(0x67e8f9, 0.14);
  g.fillCircle(64, 64, 40);

  g.fillStyle(0xecfeff, 0.08);
  g.fillCircle(64, 64, 28);

  g.generateTexture('blobGlow', 128, 128);

  /*
   * GOTA COLECCIONABLE
   */

  g.clear();

  // Halo exterior integrado.
  g.fillStyle(0x22d3ee, 0.18);
  g.fillCircle(16, 17, 15);

  // Forma de gota ligeramente vertical.
  g.fillStyle(0x67e8f9, 0.95);
  g.fillEllipse(16, 18, 21, 24);

  // Punta superior.
  g.fillTriangle(10, 13, 16, 3, 22, 13);

  // Luz interior.
  g.fillStyle(0xe0f7ff, 0.95);
  g.fillEllipse(12, 13, 7, 9);

  g.fillStyle(0xffffff, 0.9);
  g.fillCircle(10, 10, 2);

  g.generateTexture('droplet', 32, 32);

  /*
   * PARTÍCULA LÍQUIDA
   */

  g.clear();

  g.fillStyle(0x22d3ee, 0.3);
  g.fillCircle(5, 5, 5);

  g.fillStyle(0xa5f3fc, 0.85);
  g.fillCircle(5, 5, 3);

  g.fillStyle(0xffffff, 0.85);
  g.fillCircle(4, 4, 1);

  g.generateTexture('particle', 10, 10);

  /*
   * ERIZO MARINO
   */

  g.clear();

  g.fillStyle(0x1e1b4b, 1);
  g.fillCircle(32, 32, 16);

  g.lineStyle(3, 0x3730a3, 1);

  for (let i = 0; i < 12; i += 1) {
    const angle = (i / 12) * Math.PI * 2;

    g.beginPath();

    g.moveTo(
      32 + Math.cos(angle) * 14,
      32 + Math.sin(angle) * 14
    );

    g.lineTo(
      32 + Math.cos(angle) * 28,
      32 + Math.sin(angle) * 28
    );

    g.strokePath();
  }

  g.fillStyle(0x6366f1, 1);
  g.fillCircle(32, 32, 6);

  g.fillStyle(0xa5b4fc, 0.7);
  g.fillCircle(28, 28, 3);

  g.generateTexture('urchin', 64, 64);

  /*
   * CORAL CONTAMINADO
   */

  g.clear();

  g.fillStyle(0x365314, 1);
  g.fillRect(0, 0, 64, 64);

  g.fillStyle(0x4d7c0f, 0.85);
  g.fillRect(4, 4, 56, 56);

  g.fillStyle(0x84cc16, 0.5);

  for (let i = 0; i < 20; i += 1) {
    g.fillCircle(
      Math.random() * 64,
      Math.random() * 64,
      3 + Math.random() * 4
    );
  }

  g.fillStyle(0xa3e635, 0.7);
  g.fillCircle(20, 16, 4);
  g.fillCircle(48, 36, 3);
  g.fillCircle(30, 50, 5);

  g.generateTexture('coralBad', 64, 64);

  /*
   * SUELO
   */

  g.clear();

  g.fillStyle(0x0c1a2b, 1);
  g.fillRect(0, 0, 64, 64);

  g.fillStyle(0x1e293b, 1);
  g.fillRect(0, 0, 64, 6);

  g.fillStyle(0x334155, 0.65);
  g.fillRect(0, 6, 64, 3);

  g.fillStyle(0x0f172a, 1);

  for (let i = 0; i < 30; i += 1) {
    g.fillRect(
      Math.random() * 64,
      8 + Math.random() * 56,
      2,
      2
    );
  }

  g.generateTexture('ground', 64, 64);

  /*
   * ROCA / PLATAFORMA
   */

  g.clear();

  g.fillStyle(0x1e293b, 1);
  g.fillRect(0, 0, 64, 64);

  g.fillStyle(0x334155, 1);
  g.fillRect(4, 2, 56, 5);

  g.fillStyle(0x475569, 0.45);
  g.fillRect(7, 10, 45, 3);

  g.fillStyle(0x0f172a, 1);
  g.fillRect(0, 58, 64, 6);

  g.lineStyle(1, 0x475569, 0.6);
  g.strokeRect(0, 0, 64, 64);

  g.generateTexture('rock', 64, 64);

  /*
   * CORAL DECORATIVO
   */

  g.clear();

  g.fillStyle(0xe11d48, 0.7);
  g.fillRect(14, 40, 4, 20);
  g.fillRect(26, 30, 4, 30);
  g.fillRect(38, 44, 4, 18);

  g.fillStyle(0xf472b6, 1);
  g.fillCircle(16, 40, 10);

  g.fillStyle(0xfb7185, 1);
  g.fillCircle(28, 30, 8);

  g.fillStyle(0xfbbf24, 1);
  g.fillCircle(40, 44, 9);

  g.fillStyle(0xffffff, 0.25);
  g.fillCircle(13, 37, 3);
  g.fillCircle(25, 27, 2);

  g.generateTexture('coralDeco', 64, 64);

  /*
   * PORTAL
   */

  g.clear();

  g.fillStyle(0x22d3ee, 0.15);
  g.fillCircle(64, 64, 62);

  g.fillStyle(0x22d3ee, 0.4);
  g.fillCircle(64, 64, 54);

  g.fillStyle(0x67e8f9, 0.7);
  g.fillCircle(64, 64, 40);

  g.fillStyle(0x0e7490, 0.85);
  g.fillCircle(64, 64, 27);

  g.fillStyle(0xecfeff, 0.85);
  g.fillCircle(64, 64, 16);

  g.generateTexture('portal', 128, 128);

  /*
   * CHECKPOINT
   */

  g.clear();

  g.fillStyle(0x1e40af, 1);
  g.fillTriangle(24, 4, 44, 24, 24, 60);
  g.fillTriangle(24, 4, 4, 24, 24, 60);

  g.fillStyle(0x60a5fa, 0.8);
  g.fillTriangle(24, 10, 36, 26, 24, 50);

  g.fillStyle(0xbfdbfe, 0.65);
  g.fillTriangle(24, 10, 24, 50, 15, 25);

  g.generateTexture('checkpoint', 48, 64);

  /*
   * CHECKPOINT ACTIVO
   */

  g.clear();

  g.fillStyle(0x22d3ee, 1);
  g.fillTriangle(24, 4, 44, 24, 24, 60);
  g.fillTriangle(24, 4, 4, 24, 24, 60);

  g.fillStyle(0xecfeff, 0.9);
  g.fillTriangle(24, 10, 36, 26, 24, 50);

  g.fillStyle(0xffffff, 0.9);
  g.fillTriangle(24, 10, 24, 45, 17, 25);

  g.generateTexture('checkpointActive', 48, 64);

  /*
   * ALGAS
   */

  g.clear();

  g.fillStyle(0x047857, 1);
  g.fillRect(6, 40, 4, 24);

  g.fillStyle(0x059669, 1);
  g.fillEllipse(8, 42, 10, 15);

  g.fillStyle(0x10b981, 1);
  g.fillCircle(8, 32, 5);
  g.fillCircle(8, 21, 4);
  g.fillCircle(8, 12, 3);

  g.fillStyle(0x6ee7b7, 0.45);
  g.fillCircle(6, 20, 2);

  g.generateTexture('algae', 16, 64);

  /*
   * BURBUJA DE FONDO
   */

  g.clear();

  g.lineStyle(1, 0xa5f3fc, 0.65);
  g.strokeCircle(8, 8, 6);

  g.fillStyle(0xa5f3fc, 0.12);
  g.fillCircle(8, 8, 5);

  g.fillStyle(0xffffff, 0.85);
  g.fillCircle(6, 6, 2);

  g.generateTexture('bubble', 16, 16);

  /*
   * INDICADOR DE CORRIENTE
   */

  g.clear();

  g.fillStyle(0x22d3ee, 0.45);
  g.fillTriangle(0, 4, 12, 0, 12, 8);

  g.fillStyle(0xecfeff, 0.25);
  g.fillTriangle(4, 4, 11, 2, 11, 6);

  g.generateTexture('currentStreak', 12, 8);
  /*
   * PEZ PEQUEÑO
   */

  g.clear();

  // Cola.
  g.fillStyle(0x0891b2, 0.9);
  g.fillTriangle(8, 16, 0, 8, 0, 24);

  // Cuerpo.
  g.fillStyle(0x22d3ee, 0.95);
  g.fillEllipse(19, 16, 25, 15);

  // Parte luminosa.
  g.fillStyle(0xa5f3fc, 0.55);
  g.fillEllipse(16, 13, 12, 6);

  // Ojo.
  g.fillStyle(0xe0f7ff, 1);
  g.fillCircle(25, 14, 2);

  g.fillStyle(0x020617, 1);
  g.fillCircle(25.5, 14, 1);

  g.generateTexture('fishSmall', 32, 32);

  /*
   * PEZ LUMINOSO
   */

  g.clear();

  // Halo.
  g.fillStyle(0x67e8f9, 0.12);
  g.fillEllipse(24, 20, 46, 30);

  // Cola.
  g.fillStyle(0x6366f1, 0.9);
  g.fillTriangle(12, 20, 0, 9, 0, 31);

  // Cuerpo.
  g.fillStyle(0x818cf8, 0.95);
  g.fillEllipse(29, 20, 37, 20);

  // Franja bioluminiscente.
  g.fillStyle(0x67e8f9, 0.85);
  g.fillEllipse(27, 18, 23, 8);

  // Reflejo.
  g.fillStyle(0xecfeff, 0.7);
  g.fillEllipse(23, 14, 10, 4);

  // Ojo.
  g.fillStyle(0xffffff, 1);
  g.fillCircle(38, 17, 2.5);

  g.fillStyle(0x020617, 1);
  g.fillCircle(39, 17, 1.2);

  g.generateTexture('fishGlow', 48, 40);
  g.destroy();
}